// Zentrale Konstanten für die Zaunplanung
// Diese Datei sollte keine anderen Module aus dem arrangement-Ordner importieren

// entspricht etwa einer Pfostenbreite. Ecken sollten nicht näher aneinander stehen können
export const pfostenbreiteCirca = 0.08;
export const epsilon = 0.08; //pfostenbreiteCirca;
export const epsilonSq = Math.pow(epsilon, 2);
export const parallelRadEpsilon = (0.1 * Math.PI) / 180;

// Weitere Konstanten für Lichtleisten
export const INTERSECTION_EPSILON = 0.0001;
export const MAX_KABELLÄNGE = 50; // falls verwendet
export const TRAFO_KABELLÄNGE = 10; // falls verwendet
